<template v-if="!loading">
  <div v-if="pocs && pocs.length">
    <h3 class="font-weight-bolder text-primary my-5">
      {{ isDevMioActive ? 'Most read on ' + categoryName : 'Meist gelesen auf ' + categoryName }}
    </h3>
    <div class="splide newFeatureSlider" :class="aCategoryId">
        <div class="splide__track mask-container ">
          <div class="splide__list">
            <div class="splide__slide"
              v-for="(singlePoc, i) in pocs" :key="i">
              <singlePoc :singlePoc="singlePoc" :realUrl="singlePoc.realUrl" :key="i" />
            </div>
          </div>
        </div>
      </div>  
  </div>
</template>

<script>
import queryAndMutaionService from '../../services/queryAndMutaionService.js';
import Splide from '@splidejs/splide';
import singlePoc from './SinglePoc.vue';
import helperfunctions from "../../services/helperfunctions.js";


export default {
  
  name: "categoryFeature",
  components: {
    singlePoc
  },
  data() {
    return {
      loading: false,
      page: 1,
      error: false,
      result: null,
      pocs: [],
      splide: null,
      metaCount:0,
      categoryName: "",
      currentPage: 1,
      isDevMioActive: false,
    };
  },
  props: {
    aCategoryId: String,
    brandData: Object,
    categories: Array,
  },
  created() {
    if (this.aCategoryId && this.aCategoryId.length && this.brandData && this.brandData.slug) {
      this.loading = true;
      this.getPocForCategory();
    }
    if (this.categories && this.categories.length && this.aCategoryId) {
      this.categoryName = this.categories.find((cat) => cat._id === this.aCategoryId).name;
    }
    if (this.settingsPerm && this.settingsPerm.isDevMioActive) {
      this.isDevMioActive = this.settingsPerm.isDevMioActive;
    }
    // console.log("categoriescategoriescategories",this.categories)
  },

  methods: {

    getPocForCategory(){
      let catId = this.aCategoryId;
      let pageSize = 10;
      queryAndMutaionService.getPocDataForCategory(this.brandData.slug,this.brandData._id,catId,this.page,pageSize).then((data) => {
        if (data && data.pieceOfContent && data.pieceOfContent.PieceOfContent && data.pieceOfContent.PieceOfContent.length) {
          this.result = data;
          data.pieceOfContent.PieceOfContent.forEach((poc) => {
            this.pocs.push({ ...poc, realUrl: helperfunctions.generateUrlForPocs(poc) });
            this.mount_splide();
          });
        }
        this.loading = false;
      }).catch((error) => {
        this.error = error;
        this.loading = false;
      });
      this.page++;
    },

    async loadMoreData() {
        // Make an API call to fetch more data
        let catId = this.aCategoryId;
        let page = this.currentPage + 1;
        let pageSize = 10;
        queryAndMutaionService.getPocDataForCategory(this.brandData.slug,this.brandData._id,catId,page,pageSize).then((data) => {
            if (data && data.pieceOfContent && data.pieceOfContent.PieceOfContent && data.pieceOfContent.PieceOfContent.length) {
            this.result = data;
            const newPocs = data.pieceOfContent.PieceOfContent;
            this.pocs = [...this.pocs, ...newPocs];
            this.currentPage = page;
            this.mount_splide();
          }
          this.loading = false;
        }).catch((error) => {
          this.error = error;
          this.loading = false;
      });
    },


    addMovedEventListener() {
      this.splide.on("moved", (newIndex) => {
      const lastCardIndex = newIndex + this.splide.options.perPage;
        if (lastCardIndex === this.pocs.length - 2 && this.pocs.length > this.metaCount) {
            this.loadMoreData();
        }
      });
    },


    mount_splide: function () {
      let thiz = this;
      let padding = {
            right: "0rem",
            left: "0rem",
          };
      setTimeout(function () {
        if (thiz.pocs && thiz.pocs.length && thiz.pocs.length > 3) {
          padding = {
            right: "0rem",
            left: "0rem",
          };
        }
        if (!thiz.splide) {
          thiz.splide = new Splide('.'+thiz.aCategoryId, {
            classes: {
              arrows : 'splide__arrows arrows',
              prev  : 'splide__arrow--prev prev',
              next  : 'splide__arrow--next next',
            },
            perPage: 3,
            perMove: 1,
            gap: '1rem',
            rewind: false,
            pagination: false,
            padding:padding,
            breakpoints: {
            1600: {
              perPage: 3,
            },
            1280: {
              perPage: 2,
            },
            991: {
              perPage: 2,
            },
            767: {
              perPage: 1,
            },
            575: {
              perPage: 1,
              padding: { left: '0rem', right: '5rem' },
              arrows: false, 
              start  : 1,
            },
          },
            
          });
          thiz.splide.mount();
          thiz.addMovedEventListener();
        } else {
          thiz.splide.refresh(); // Refresh the existing Splide instance
        }
      }, 100);
    },

  },

};
</script>

<style scoped>
    .mask-container {
    position: relative;
    overflow: hidden;
    }

    .mask-container::after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 94%;
    transform: translateX(-50%);
    width: 22%;
    background: linear-gradient(to right, transparent, white);
    filter: blur(10px);
    }

    .prev {
        left: 68.5rem !important;
        background-color: transparent!important;
    }
    
    .next {
        right: -0.5rem !important;
        background-color: transparent!important;
    }
    
    .arrows {
        position: relative !important;
        top: -20px;
    }

    @media screen and (max-width: 1679px) {
        .prev {
            left: 54rem !important;
        }
        
        .next {
            right: 0rem !important;
        }
        
        .arrows {
            top: -20px;
        }
    }
    @media screen and (max-width: 1359px) {
        .prev {
            left: 46rem !important;
        }
        
        .next {
            right: 0rem !important;
        }
        
        .arrows {
            top: -20px;
        }
    }
    @media screen and (max-width: 1199px) {
        .prev {
            left: 38rem !important;
        }
        
        .next {
            right: 0rem !important;
        }
        
        .arrows {
            top: -20px;
        }
    }
    @media screen and (max-width: 767px) {
        .prev {
            left: 26rem !important;
        }
        
        .next {
            right: 0rem !important;
        }
        
        .arrows {
            top: -20px;
        }
    }
</style>